module.exports = __webpack_public_path__ + "static/img/icon_zj_08.456950fd.png";